import { useCallback, useRef, useState } from "react";
import { DEFAULT_PAGE_SIZE, PAGE_SIZE_OPTIONS, PAGE_SIZE_STORAGE_KEY, } from "../utils/constants";
var readStoredPageSize = function () {
    var stored = Number(localStorage.getItem(PAGE_SIZE_STORAGE_KEY));
    return PAGE_SIZE_OPTIONS.includes(stored) ? stored : DEFAULT_PAGE_SIZE;
};
export var usePageSize = function (onReset) {
    var _a = useState(readStoredPageSize), pageSize = _a[0], setPageSizeState = _a[1];
    var onResetRef = useRef(onReset);
    onResetRef.current = onReset;
    var handlePageSizeChange = useCallback(function (size) {
        var _a;
        setPageSizeState(size);
        localStorage.setItem(PAGE_SIZE_STORAGE_KEY, String(size));
        (_a = onResetRef.current) === null || _a === void 0 ? void 0 : _a.call(onResetRef);
    }, []);
    return { pageSize: pageSize, handlePageSizeChange: handlePageSizeChange };
};
